export const getUsernameError = username => {
  if (!username) {
    return "Username is required";
  }
  if (username.length < 4) {
    return "Username is too short";
  }
  return null;
};
